$(function() {
  var loggedInStatus = $('.aboutUs-container').attr('data-status');
  var header = $('.page-aboutUsPage header .navbar').outerHeight();
  var headerHeight = loggedInStatus === 'False' ? header : header + 30;

  function scrollToSection(event) {
    event.preventDefault();
    $($(this).attr('href'))[0].scrollIntoView();
    scrollBy(0, -headerHeight);
  }
  function readOnEnter(e) {
    let keyCode = window.event ? e.which : e.keyCode;
    let getTitle = $(this).attr('data-title');
    $('.readTitleOnEnter').text(' ');
    if (keyCode === 13 || keyCode === 1) {
      setTimeout($('.readTitleOnEnter').text(getTitle + ' opens'), 200);
    }
  }
  $('.aboutus-index-tiles a').on('click', scrollToSection);
  $(document).on('keyup click', '.aboutus-index-tiles a', readOnEnter);
});
